import React from 'react';
import { withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import ConfirmButton from '../Buttons/ConfirmButton';
// import { addRemoveFavouriteTeacher } from "../../redux/college/college.actions"
import { tagsToArray } from '../../Components-Pages/JobBoard/utils';
import { connect } from 'react-redux';
import {
  addFavouriteListing,
  removeFavouriteListing,
} from '../../redux/homePage/homePage.actions';
import './JobListingCard2.css';
import { getFullDeliveryModeString, hasClosedDatePassed } from '../../Helper/JobHelper';
import ReactTooltip from "react-tooltip";

function JobListingCard(props) {
  const { job, isApplied, onClickTag, minWidth, isViewAsTeacher, simpleQualifications } = props;

  const myFavourites = props.myFavourites || [];

  const descLength = minWidth ? 199 : 499;

  const isClosed = hasClosedDatePassed(job.close_date)

  const goToListing = () => {
    props.history.push(`/JobListing/${job._id}`);
  };

  const goToEditListing = () => {
    props.history.push(`/JobListing/Edit/${job._id}`);
  };

  const isFaved = myFavourites.find((obj) => obj.listing_id === job._id);

  const toggleFavourite = () => {
    if (isFaved) {
      props.removeFavouriteListing(props.job._id);
    } else {
      props.addFavouriteListing(props.job._id);
    }
  };

  const favHeart = () => {
    return isFaved ? (
      <Icon
        name='heart'
        size='big'
        color='red'
        className='job-card-heart'
        onClick={toggleFavourite}
        title='Remove from Favourites'
      />
    ) : (
      <Icon
        name='heart outline'
        size='big'
        color='grey'
        className='job-card-heart'
        onClick={toggleFavourite}
        title='Add to Favourites'
      />
    );
  };

  const openCloseStatus = () => {
    if (job.status !== 'draft') {
      return isClosed ? (
        <Icon
          name='circle outline'
          className='job-card-circle'
          title='Closed'
        />
      ) : (
        <Icon
          name='circle'
          className='job-card-circle'
          title='Open'
        />
      )
    }
  }

  const getTagName = (levelID) => {
		const levelItem = simpleQualifications.find(ele => ele._id === levelID)
		return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
			: levelID
	};

  return (
    <div className={'job-card-outer' + (minWidth ? ' job-card-small' : '')}>
      {/* <Link
        to={"/NavigateToShareProfile?id=" + user._id}
        to="/"
        target="blank"
        className="search-card-link"
      > */}
      <div
        className={
          'job-card-container' + (isApplied ? ' job-card-applied' : '')
        }
      >
        <div className='w-100 d-flex justify-content-between'>
          <div className='d-flex align-items-center mb-2'>
            <div className='job-card-logo-container'>
              <img
                className='job-card-logo'
                src={job.institution_logo}
                alt=''
              />
            </div>
            <h3 className='job-card-inst-name'>{job.institution_name}</h3>
          </div>
          <div className='d-flex align-items-center mb-1'>
            {job.status === 'draft' && <h3>[Draft]</h3>}
          </div>
        </div>
        <div className='job-card-container-inner p-3'>
          <div className='w-100'>
            <h2 className='job-card-listing-name mb-3'>{job.title}</h2>
            <h3 className='job-card-location my-2'>
              <Icon
                name='map marker alternate'
                size='small'
                className='job-listing-icon'
              />
              {job._id === "63ce1dcc4586226bef68eb11"
                ? "Melbourne, Sydney, Brisbane, Adelaide"
                : job.online ? "Online" : job.location || ""}
              {/* job.delivery_mode
                ? getFullDeliveryModeString(job.delivery_mode)
                : job.online
                ? 'Online'
                : 'On campus' */}
            </h3>
            <hr className='search-card-hr' />
            <p className='job-card-description mt-3 mb-4'>
              {job.description?.substring(0, descLength)}
              {job.description?.length > descLength && '...'}
            </p>
            <div className='job-card-tags mb-3'>
              {/* is this supposed to be an object? Was not an array like in dummy data */}
              {job.selected_tags.map((tag, index) => (
                <div
                  key={`${index}-${tag}`}
                  className='job-card-tag'
                  onClick={() => onClickTag(tag)}
                >
                  {getTagName(tag)}
                </div>
              ))}
            </div>
          </div>
          <ConfirmButton
              className='mb-0 mt-3'
              onClick={goToListing}
              disabled={isViewAsTeacher && isClosed && !isApplied}
            >
            <div data-tip={isViewAsTeacher && isClosed && !isApplied ? "Job Closed" : ""}>
              {isViewAsTeacher
                ? isApplied
                  ? 'APPLIED - VIEW LISTING'
                  : 'READ MORE & APPLY'
                : 'VIEW & EDIT LISTING'}
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                // id={`disabledMessage${props.index}`}
                effect="solid"
              />
            </div>
          </ConfirmButton>
        </div>
      </div>
      {/* </Link> */}
      {isViewAsTeacher && favHeart()}
      {!isViewAsTeacher && openCloseStatus()}
    </div>
  );
}

const mapStateToProps = (state) => ({
  simpleQualifications: state.user?.simpleQualifications || []
})

const mapDispatchToProps = (dispatch) => ({
  addFavouriteListing: (listing_id) =>
    dispatch(addFavouriteListing(listing_id)),
  removeFavouriteListing: (listing_id) =>
    dispatch(removeFavouriteListing(listing_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobListingCard));
